import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProfileImage from "../images/9R-logo.png";
import AOS from "aos";
import "aos/dist/aos.css";
import ShareButton from "./ShareButton";

const Header = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });

    window.addEventListener("load", () => {
      AOS.refresh();
    });
    window.addEventListener("scroll", () => {
      AOS.refresh();
    });

    return () => {
      window.removeEventListener("load", () => AOS.refresh());
      window.removeEventListener("scroll", () => AOS.refresh());
    };
  }, []);

  return (
    <section className="">
      <Container fluid>
        <Row>
          <Col lg={12} className="p-0">
            <div className="page1">
              <div className="container">
                <div
                  className="profile_image_outer d-flex justify-content-center"
                  data-aos="fade-up"
                >
                  <ShareButton />
                  <img
                    alt="ProfileImage"
                    src={ProfileImage}
                    className="ProfileImage p-4"
                    data-aos="zoom-in"
                    data-aos-duration="1500"
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Header;
